<section class="notifications">
  <div *ngFor="let item of notifications" class="notifications__item" [class.viewed]="item.viewed">
    <a (click)="showNotificationItem(item)">
      <h4>{{ item.title }}</h4>
    </a>
    <span>{{ item.created | date }}</span>
    <p>{{ item.description | slice: 0: 50}}</p>
  </div>
</section>

<div *ngIf="withoutNotification.event.title && !notifications.length" class="without-notification">
  <div class="without-notification_event">
    <p><b>ПОЗДРАВЛЯЕМ!</b></p>
    <p><b>Ваш ребенок принял участие в турнире</b></p>
    <p>"{{ withoutNotification.event.title }}"</p>
    <p>{{ withoutNotification.event.date|date:"dd.MM.yyyy" }}&nbsp;г.</p>
  </div>
  <div class="without-notification_description" [innerHTML]="withoutNotification.notification.description"></div>
</div>

<div *ngIf="!withoutNotification.event.title && !notifications.length && isParent" class="without-notification">
  <div class="without-notification_event">
    <p><b>ПОЗДРАВЛЯЕМ С УСПЕШНОЙ РЕГИСТРАЦИЕЙ!</b></p>
    <p><b>На данный момент результаты ваших детей не готовы, 
    как только они будут занесены, 
    мы отправим результаты вам на почту, а также внесем их сюда.</b></p>
  </div>
</div>
